module.exports = __webpack_public_path__ + "media/src/images/bg/bg8-3492b465ce753ca50495ee1b530f3602.jpg";